import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { REDACTED_VALUE } from "@/api/constants";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function isRedacted(value: unknown): boolean {
  return value === REDACTED_VALUE;
}

export function maskValue(value: unknown): string {
  return isRedacted(value) ? "••••••••" : String(value);
}

export function safeNextPath(next: string | null | undefined, fallback = "/"): string {
  if (!next) return fallback;
  if (!next.startsWith("/") || next.startsWith("//") || next.startsWith("/login")) return fallback;
  return next;
}

export function mergeSecretFields(
  formValues: Record<string, unknown>,
  secretFields: string[]
): Record<string, unknown> {
  const result: Record<string, unknown> = {};
  for (const [key, val] of Object.entries(formValues)) {
    if (secretFields.includes(key)) {
      if (val === REDACTED_VALUE || val === undefined) continue;
    }
    result[key] = val;
  }
  return result;
}
